export default __webpack_public_path__ + "static/helene-5ef3dd2e363cd3137a4a44fed64154b5.jpg";